import axios from "axios";
import API_BASE_ROOT from "../config/apiConfig";

const API_BASE_URL = `${API_BASE_ROOT}/auth`; // from centralized base // 💥 Use your Spring Boot URL

export const signup = async (signupData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/signup`, signupData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Signup failed!";
  }
};

export const login = async (phone, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, null, {
      params: { phone, password },
    });
    localStorage.setItem("user", JSON.stringify(response.data));
    window.dispatchEvent(new Event("userLoggedIn"));

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Login failed!";
  }
};

export const getCurrentWeather = async () => {
  try {
    const response = await axios.get("https://api.open-meteo.com/v1/forecast", {
      params: {
        latitude: 17.385044,
        longitude: 78.486671,
        current_weather: true,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Weather fetch failed!";
  }
};

export const sendOtp = (email) => {
  return axios.post(`${API_BASE_URL}/send-otp`, { email });
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/verify-otp`, {
      email,
      otp,
    });

    if (response.data && response.data.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));
      window.dispatchEvent(new Event("userLoggedIn"));
    }

    return response;
  } catch (error) {
    throw error.response ? error.response.data : "OTP verification failed!";
  }
};

export const completeSignup = async ({ phone, name, email }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/complete-otp-signup`, {
      phone,
      name,
      email,
    });

    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
      window.dispatchEvent(new Event("userLoggedIn"));
    }

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Signup failed!";
  }
};

export const checkEmailExists = async (email) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/check-email`, {
      params: { email },
    });
    return response.data.exists; // assuming response returns { exists: true/false }
  } catch (error) {
    throw "Email check failed!";
  }
};

export const checkPhoneExists = async (phone) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/check-phone`, {
      params: { phone },
    });
    return response.data.exists;
  } catch (error) {
    throw "Phone check failed!";
  }
};
